import React from 'react';
import { KeywordAdClicksColumnChart } from 'src/components/BeaconV2Components/ExperimentalLayout/Segments/KeywordsSearch/KeywordAdClicksColumnChart';
import KeywordAdClicksSpline from 'src/components/BeaconV2Components/ExperimentalLayout/Segments/KeywordsSearch/KeywordAdClicksSpline';
import KeywordSearchOrganicTrafficSpline from 'src/components/BeaconV2Components/ExperimentalLayout/Segments/KeywordsSearch/KeywordSearchOrganicTrafficSpline';
import useKeywordSearchRequestBuilder from 'src/components/BeaconV2Components/ExperimentalLayout/Segments/KeywordsSearch/useKeywordSearchRequestBuilder';
import { BeaconProSidebarFilters } from 'src/components/BeaconV2Components/ExperimentalLayout/Topics/TopicBuilder/Filters/constants';
import TopicBuilderColumnChart from 'src/components/BeaconV2Components/ExperimentalLayout/Topics/TopicBuilder/Visualizations/TopicBuilderColumnChart';
import {
  FILTER_OPERATION,
  useSavedSearchBuilder
} from 'src/components/BeaconV2Components/ExperimentalLayout/Topics/TopicBuilder/hooks/useSavedSearchBuilder';
import MetricListContainer from 'src/components/BeaconV2Components/MetricList/MetricListContainer';
import { KeywordColumnDefinition } from 'src/components/BeaconV2Components/MetricList/headColumnDefinitions';
import { SlCancelButton } from 'src/components/BeaconV2Components/SlButtons/SlCancelButton';

/**
 * Used for the legacy topic builder.
 * Renders a table containing keywords and their metrics and additional visualizations that are filtered via sidebar.
 */
export const LegacyTopicBuilderCreateResults = () => {
  const [hoveredIndex, setHoveredIndex] = React.useState(null);

  const { updateSavedSearch } = useSavedSearchBuilder();
  const keywordSearchRequestBuilder = useKeywordSearchRequestBuilder('retailSales');
  // Handles quick exclude button click
  const handleExcludeButtonClick = (term: string) => {
    updateSavedSearch({
      operation: FILTER_OPERATION.Add,
      key: BeaconProSidebarFilters.ExcludedSearchTerm.filterKey,
      newValue: term
    });
  };

  const additionalColumnDefs = [
    {
      headerName: '',
      tableColumnProps: {
        style: {
          width: '50px'
        }
      },
      valueFormatter: (_, row, index) => {
        const { searchTerm } = row;

        if (hoveredIndex === index) {
          return <SlCancelButton onClick={() => handleExcludeButtonClick(searchTerm)} />;
        } else {
          return null;
        }
      }
    }
  ];
  return (
    <>
      <MetricListContainer
        appTableProps={{
          onRowEnter: (_u, _w, index) => setHoveredIndex(index),
          onRowLeave: () => setHoveredIndex(null)
        }}
        additionalColumnDefs={additionalColumnDefs}
        loading={false}
        headColumnDefinition={KeywordColumnDefinition}
        fields={[
          {
            name: 'organicClicks',
            comparisonFormatter() {
              return null;
            }
          },
          {
            name: 'adClicks',
            comparisonFormatter() {
              return null;
            }
          },
          {
            name: 'totalClicks',
            comparisonFormatter() {
              return null;
            }
          },
          {
            name: 'adSpend',
            comparisonFormatter() {
              return null;
            }
          }
        ]}
        showHeader={false}
        showGrid={false}
        indexName="traffic"
        sortFieldName="totalClicks"
        groupBy="searchTerm"
        skeletonRows={20}
        useTableDataProps={{
          buildRequest: keywordSearchRequestBuilder()
        }}
      />
      <KeywordSearchOrganicTrafficSpline />
      <TopicBuilderColumnChart />
      <KeywordAdClicksSpline />
      <KeywordAdClicksColumnChart />
    </>
  );
};
